"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapacityUnitShortLabels = exports.CapacityUnitLabels = exports.CapacityUnit = exports.CapacityUnits = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.CapacityUnits = ['GALLONS', 'CUBIC_YARDS', 'CUBIC_METERS'];
exports.CapacityUnit = typebox_1.Type.Union(exports.CapacityUnits.map((type) => typebox_1.Type.Literal(type)));
exports.CapacityUnitLabels = {
    GALLONS: 'Gallons',
    CUBIC_YARDS: 'Cubic Yards',
    CUBIC_METERS: 'Cubic Meters',
};
exports.CapacityUnitShortLabels = {
    GALLONS: 'gal',
    CUBIC_YARDS: 'yd',
    CUBIC_METERS: 'm3',
};
//# sourceMappingURL=capacity-unit.js.map